module.exports = __webpack_public_path__ + "static/media/cross.4bc51f3e.svg";